import { createWebHistory, createRouter } from "vue-router";

const routes = [
{
  path: "/",
  name: "index",
  component: () => import('@/pages/index/index.vue'),
},
{
  path: "/:category",
  name: "catalogProducts",
  component: () => import("@/pages/shop/category.vue"),
  props: true
  //props: { category: 176649418 }
  },
  {
    path: "/:category/:product",
    name: "catalogProduct",
    component: () => import('@/pages/shop/product.vue'),
    props: true
  },
  {
    path: "/checkout",
    name: "checkoutPage",
    component: () => import('@/pages/shop/checkout.vue'),
    props: true
  },
]

  /*
      {
      path: "/:catchAll(.*)",
      name: "Error",
      component: () => import('@/pages/specialpages/error.vue'),
    }, 
  */
  

  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  export default router;